import { gql } from "@apollo/client";

export const GET_ALL_COUNTRIES = gql`
  query GetAllCountries {
    getAllCountries {
      id
      name
      phone_code
      currency
      currency_symbol
      tld
      code 
      is_active
      region {
      name
      }
      states {
        id
        name
        cities{
        id
        name}
      }
    }
  }
`;
